(function () {
  if(document.body.id !== 'topics') return false
  var archives = document.querySelector('.js-topics-menu-archives')
  var title = archives.querySelector('.title')
  var list = archives.querySelector('.list')
  title.addEventListener('click', showMenu)
  var listH = list.scrollHeight
  function showMenu() {
    title.removeEventListener('click', showMenu)
    title.classList.add('is-show')
    list.style.height = listH + 'px'
    title.addEventListener('click', hideMenu)
  }

  function hideMenu() {
    title.removeEventListener('click', hideMenu)
    title.classList.remove('is-show')
    list.style.height = 0
    title.addEventListener('click', showMenu)
  }
}());